// Утилиты для Form6
import { parseDecimal } from '../../../utils/decimalUtils';

// Функция для расчета СКС
export const calculateSKS = (item) => {
  // Преобразуем все значения в числа
  const i = Number(item.i_zdor) || 0;
  const ii = Number(item.ii_oslab) || 0;
  const iii = Number(item.iii_sosl) || 0;
  const iv = Number(item.iv_usyh) || 0;
  const va = Number(item.va_svss) || 0;
  const vb = Number(item.vb_svvv) || 0;
  const vc = Number(item.vc_svbl) || 0;
  const vg = Number(item.vg_stss) || 0;
  const vd = Number(item.vd_stvv) || 0;
  const ve = Number(item.ve_stbl) || 0;
  
  // Формула СКС: (I*1+II*2+III*3+IV*4+(V(A)+V(Б)+V(В)+V(Г)+V(Д)+V(E))*5)/100
  const numerator = (i * 1) + (ii * 2) + (iii * 3) + (iv * 4) + ((va + vb + vc + vg + vd + ve) * 5);
  const denominator = 100;
  
  if (denominator === 0) return 0;
  
  const result = numerator / denominator;
  return Math.round(result * 100) / 100; // Округляем до 2 знаков после запятой
};

// Функция для расчета отпада общего
export const calculateOtpadObsh = (item) => {
  const iv = Number(item.iv_usyh) || 0;
  const va = Number(item.va_svss) || 0;
  const vb = Number(item.vb_svvv) || 0;
  const vc = Number(item.vc_svbl) || 0;
  const vg = Number(item.vg_stss) || 0;
  const vd = Number(item.vd_stvv) || 0;
  const ve = Number(item.ve_stbl) || 0;
  
  // Отпад общий = IV + VA + VB + VC + VГ + VD + VE
  return iv + va + vb + vc + vg + vd + ve;
};

// Функция для расчета отпада текущего
export const calculateOtpadTek = (item) => {
  const iv = Number(item.iv_usyh) || 0;
  const va = Number(item.va_svss) || 0;
  const vb = Number(item.vb_svvv) || 0;
  const vc = Number(item.vc_svbl) || 0;
  
  // Отпад текущий = IV + VA + VB + VC
  return iv + va + vb + vc;
};

// Функция для расчета фактической полноты (сумма полноты всех ярусов)
export const calculateFaktPolnota = (independentForm2Data) => {
  if (!independentForm2Data || !independentForm2Data.yarusy_dependent) {
    return 0;
  }
  
  const sum = independentForm2Data.yarusy_dependent.reduce((total, yarus) => {
    const polnota = parseDecimal(yarus.polnota) || 0;
    return total + polnota;
  }, 0);
  
  return sum;
};

// Функция для расчета расчётной остаточной полноты
export const calculateRaschetnayaOstatochnayaPolnota = (independentForm2Data, otpadObshTotal) => {
  const faktPolnota = calculateFaktPolnota(independentForm2Data);
  const otpadObsh = parseDecimal(otpadObshTotal) || 0;
  
  // Расчётная остаточная полнота = Фактическая полнота - Фактическая полнота * (отпад общий / 100)
  const result = faktPolnota - (faktPolnota * otpadObsh / 100);
  
  return Math.max(0, result); // Не может быть отрицательным
};

// Функция для расчета класса устойчивости насаждения
export const calculateKlassUstoychivostiNasazhdeniya = (sksTotal) => {
  const sks = parseDecimal(sksTotal);
  // Нулевой или отсутствующий СКС не описывает состояние насаждения.
  if (!Number.isFinite(sks) || sks <= 0) return '';
  
  if (sks < 1.50) {
    return '1-устойчивые насаждения';
  } else if (sks >= 1.50 && sks <= 4.50) {
    return '2-насаждения с нарушенной устойчивостью';
  } else if (sks > 4.50) {
    return '3-насаждения с утраченной устойчивостью';
  }
  
  return '';
};

